<template lang="pug">
div
  DataFilter(
    v-show="ativo",
    ref="dataFilter",
    :classes="'faq-card pa-3'",
    :filterProps="filterProps",
    :items="artigosTabela",
    :search-filter="filtrarBuscaArtigos",
    :paginate="false",
    :render-empty="true"
  )
    template(v-slot:actions)
      v-btn.faq-btn-action.text-none.ml-2(
        v-if="podeEditar",
        color="primary",
        outlined,
        small,
        title="Adicionar",
        @click="novoArtigo()"
      )
        v-icon(left, small) mdi-plus
        span Adicionar

    template(v-slot:default="{ items }")
      v-data-table.faq-artigos-data-table(
        v-model="artigosSelecionados",
        :headers="headersArtigosVisiveis",
        :items="items",
        :items-per-page="20",
        :footer-props="footerProps",
        item-key="id",
        checkbox-color="primary",
        :show-select="podeEditar",
        dense
      )
        template(v-slot:no-data)
          .faq-artigos-empty Nenhum registro encontrado
        template(v-slot:item.titulo="{ item }")
          a(@click.prevent="abrirArtigo(item.artigo)", href="#") {{ item.titulo && item.titulo.length > 60 ? `${item.titulo.slice(0, 60)}...` : item.titulo }}
        template(v-slot:item.permissao="{ item }")
          v-tooltip(
            v-if="item.permissao === 'privado'",
            content-class="faq-tooltip",
            bottom
          )
            template(v-slot:activator="{ on, attrs }")
              span.d-inline-flex(
                v-bind="attrs",
                v-on="on",
                tabindex="0",
                aria-label="Artigo privado"
              )
                v-icon(small, color="primary", aria-hidden="true") mdi-headset
            span Artigo privado
        template(v-slot:item.categoria="{ item }")
          span {{ item.categorias[0] || "-" }}
          v-tooltip(
            content-class="faq-tooltip",
            v-if="item.categorias.length > 1",
            bottom
          )
            template(v-slot:activator="{ on, attrs }")
              v-avatar.ml-4(
                v-bind="attrs",
                v-on="on",
                size="20",
                color="primary",
                tabindex="0",
                :aria-label="`${item.categorias.length - 1} outras categorias`"
              )
                span.white--text.text-caption +{{ item.categorias.length - 1 }}
            div(
              v-for="(categoria, index) in item.categorias.slice(1)",
              :key="index"
            ) {{ categoria }}
        template(v-slot:item.secaoTitulo="{ item }")
          span {{ item.secoes[0] || "-" }}
          v-tooltip(
            content-class="faq-tooltip",
            v-if="item.secoes.length > 1",
            bottom
          )
            template(v-slot:activator="{ on, attrs }")
              v-avatar.ml-4(
                v-bind="attrs",
                v-on="on",
                size="20",
                color="primary",
                tabindex="0",
                :aria-label="`${item.secoes.length - 1} outras seções`"
              )
                span.white--text.text-caption +{{ item.secoes.length - 1 }}
            div(v-for="(secao, index) in item.secoes.slice(1)", :key="index") {{ secao }}
        template(v-slot:item.status="{ item }")
          faq-status(:status="item.status")
        template(v-slot:item.video="{ item }")
          v-tooltip(content-class="faq-tooltip", bottom)
            template(v-slot:activator="{ on, attrs }")
              span.d-inline-flex(
                v-bind="attrs",
                v-on="on",
                tabindex="0",
                :aria-label="item.video ? 'Contém vídeo' : 'Não contém vídeo'"
              )
                v-icon(
                  small,
                  :color="item.video ? 'primary' : 'grey'",
                  aria-hidden="true"
                ) mdi-video
            span {{ item.video ? "Contém vídeo" : "Não contém vídeo" }}
        template(v-slot:item.metricas="{ item }")
          .d-flex.align-center
            v-tooltip(content-class="faq-tooltip", bottom)
              template(v-slot:activator="{ on, attrs }")
                span.d-inline-flex.align-center.mr-3(
                  v-bind="attrs",
                  v-on="on",
                  :aria-label="'Visualizações: ' + (item.visualizacoes || 0)"
                )
                  v-icon.mr-1(small, color="black") mdi-eye-outline
                  span {{ item.visualizacoes || 0 }}
              span Visualizações
            v-tooltip(content-class="faq-tooltip", bottom)
              template(v-slot:activator="{ on, attrs }")
                span.d-inline-flex.align-center.mr-3(
                  v-bind="attrs",
                  v-on="on",
                  :aria-label="'Avaliações positivas: ' + (item.curtidasPositivas || 0)"
                )
                  v-icon.mr-1(small, color="black") mdi-thumb-up-outline
                  span {{ item.curtidasPositivas || 0 }}
              span Avaliações positivas
            v-tooltip(content-class="faq-tooltip", bottom)
              template(v-slot:activator="{ on, attrs }")
                span.d-inline-flex.align-center(
                  v-bind="attrs",
                  v-on="on",
                  :aria-label="'Avaliações negativas: ' + (item.curtidasNegativas || 0)"
                )
                  v-icon.mr-1(small, color="black") mdi-thumb-down-outline
                  span {{ item.curtidasNegativas || 0 }}
              span Avaliações negativas
        template(v-slot:item.criadoem="{ item }")
          span {{ formatarDataArtigo(item.criadoem) }}
        template(v-slot:item.ultimoeditor="{ item }")
          span {{ item.ultimoeditor || "-" }}
        template(v-slot:item.atualizadoem="{ item }")
          span {{ formatarDataArtigo(item.atualizadoem) }}
        template(v-slot:item.actions="{ item }")
          .d-flex
            v-tooltip(content-class="faq-tooltip", bottom)
              template(v-slot:activator="{ on, attrs }")
                v-btn(
                  icon,
                  x-small,
                  dense,
                  color="info",
                  v-bind="attrs",
                  v-on="on",
                  aria-label="Visualizar",
                  @click="abrirArtigo(item.artigo)"
                )
                  v-icon(small) mdi-eye-outline
              span Visualizar
            v-tooltip(v-if="podeEditar", content-class="faq-tooltip", bottom)
              template(v-slot:activator="{ on, attrs }")
                v-btn(
                  icon,
                  x-small,
                  dense,
                  color="primary",
                  v-bind="attrs",
                  v-on="on",
                  aria-label="Editar",
                  @click="editarArtigo(item.secao, item.artigo)"
                )
                  v-icon(small) mdi-pencil-circle-outline
              span Editar
            v-tooltip(v-if="podeEditar", content-class="faq-tooltip", bottom)
              template(v-slot:activator="{ on, attrs }")
                v-btn(
                  icon,
                  x-small,
                  dense,
                  color="error",
                  v-bind="attrs",
                  v-on="on",
                  aria-label="Excluir",
                  @click="solicitarExclusaoArtigoCompleto(item.artigo)"
                )
                  v-icon(small) mdi-delete
              span Excluir
        template(v-slot:footer.prepend)
          .d-flex.align-center.flex-wrap.faq-artigos-footer
            v-menu(v-if="podeEditar", offset-y)
              template(v-slot:activator="{ on, attrs }")
                v-btn.faq-btn-action.text-none(
                  v-bind="attrs",
                  v-on="on",
                  outlined,
                  small,
                  :disabled="artigosSelecionados.length === 0 || alterandoStatus"
                )
                  span Alterar status
                  v-icon(right, small) mdi-chevron-down
              v-list(dense)
                v-list-item(
                  @click="solicitarAlteracaoStatusArtigos('publicado')"
                )
                  v-list-item-icon
                    v-icon(color="success") mdi-publish
                  v-list-item-title Publicar
                v-list-item(
                  @click="solicitarAlteracaoStatusArtigos('rascunho')"
                )
                  v-list-item-icon
                    v-icon(color="grey") mdi-file-edit-outline
                  v-list-item-title Mover para rascunho
                v-list-item(
                  @click="solicitarAlteracaoStatusArtigos('despublicado')"
                )
                  v-list-item-icon
                    v-icon(color="error") mdi-publish-off
                  v-list-item-title Despublicar
            v-divider.mx-2(v-if="podeEditar", vertical)
            v-chip(
              small,
              :color="statusFiltrado ? 'grey darken-2' : 'primary'",
              :outlined="!!statusFiltrado",
              @click="filtrarStatus(null)",
              role="button",
              :aria-pressed="!statusFiltrado"
            )
              | Total: {{ totaisStatus.total }}
            v-chip(
              small,
              :color="statusFiltrado === 'rascunho' ? 'primary' : 'grey darken-2'",
              :outlined="statusFiltrado !== 'rascunho'",
              @click="filtrarStatus('rascunho')",
              role="button",
              :aria-pressed="statusFiltrado === 'rascunho'"
            )
              | Rascunho: {{ totaisStatus.rascunhos }}
            v-chip(
              small,
              :color="statusFiltrado === 'publicado' ? 'primary' : 'grey darken-2'",
              :outlined="statusFiltrado !== 'publicado'",
              @click="filtrarStatus('publicado')",
              role="button",
              :aria-pressed="statusFiltrado === 'publicado'"
            )
              | Publicado: {{ totaisStatus.publicados }}
            v-chip(
              small,
              :color="statusFiltrado === 'despublicado' ? 'primary' : 'grey darken-2'",
              :outlined="statusFiltrado !== 'despublicado'",
              @click="filtrarStatus('despublicado')",
              role="button",
              :aria-pressed="statusFiltrado === 'despublicado'"
            )
              | Despublicado: {{ totaisStatus.despublicados }}

  //- Dialog Confirmar Alteração de Status
  v-dialog(
    :value="dialogConfirmacaoStatus",
    @input="dialogConfirmacaoStatus = $event",
    persistent,
    max-width="500"
  )
    v-card.faq-card(outlined)
      v-card-title.faq-dialog-header Confirmar alteração de status
      v-card-text.pt-6
        p.mb-0 Deseja alterar o status de {{ artigosSelecionados.length }} artigo(s) selecionado(s) para {{ nomeStatus(statusArtigosPendente).toLowerCase() }}?
      v-card-actions.faq-dialog-actions.mr-0
        v-spacer
        v-btn.faq-btn-action.text-none(
          outlined,
          small,
          :disabled="alterandoStatus",
          @click="cancelarAlteracaoStatusArtigos()"
        ) Cancelar
        v-btn.faq-btn-primary.text-none(
          color="primary",
          small,
          :loading="alterandoStatus",
          :disabled="alterandoStatus",
          @click="confirmarAlteracaoStatusArtigos()"
        ) Confirmar

  //- Dialog Confirmar Exclusão
  v-dialog(
    :value="dialogConfirmacaoExclusao",
    @input="dialogConfirmacaoExclusao = $event",
    persistent,
    max-width="500"
  )
    v-card.faq-card(outlined)
      v-card-title.faq-dialog-header Confirmar exclusão do artigo
      v-card-text.pt-6
        p.mb-0
          | Tem certeza que deseja excluir o artigo
          strong {{ artigoExclusaoPendente && artigoExclusaoPendente.titulo }}
          |
          | de todas as seções? Esta ação não pode ser desfeita.
        p.mt-3.mb-0 Os vínculos com seções, acessos e avaliações associados ao artigo também serão excluídos.
      v-card-actions.faq-dialog-actions.mr-0
        v-spacer
        v-btn.faq-btn-action.text-none(
          outlined,
          small,
          @click="cancelarExclusaoArtigo()",
          :disabled="excluindoArtigo"
        ) Cancelar
        v-btn.text-none(
          color="error",
          small,
          @click="confirmarExclusaoArtigo()",
          :loading="excluindoArtigo",
          :disabled="excluindoArtigo"
        )
          span Excluir artigo

  //- Dialog Visualizar Artigo
  v-dialog(
    content-class="faq-preview-dialog",
    :value="dialogArtigo",
    @input="onDialogArtigoInput($event)",
    max-width="1600"
  )
    v-card.faq-card.faq-preview-card(outlined)
      v-card-title.faq-dialog-header.d-flex.align-center
        span {{ artigoVisualizado ? artigoVisualizado.titulo : "Carregando artigo..." }}
        v-spacer
        v-btn(icon, small, aria-label="Fechar artigo", @click="fecharArtigo()")
          v-icon mdi-close
      v-card-text.pt-4
        .faq-preview-loading.d-flex.justify-center.align-center(
          v-if="carregandoVisualizacao",
          role="status"
        )
          v-progress-circular(indeterminate, color="primary")
          span.ml-4 Carregando conteúdo do artigo...
        .error--text.py-8.text-center(v-else-if="erroVisualizacao")
          | {{ erroVisualizacao }}
        template(v-else-if="artigoVisualizado")
          .caption.grey--text.mb-4
            span Atualizado em {{ formatarDataArtigo(artigoVisualizado.atualizadoem) }}
          v-divider.mb-4
          .faq-artigo-conteudo(v-html="conteudoVisualizado")
      v-card-actions.faq-dialog-actions.mr-0
        v-spacer
        v-btn.faq-btn-action.text-none(
          outlined,
          small,
          @click="fecharArtigo()"
        )
          span Fechar

  //- Dialog Incluir/Editar Artigo
  v-dialog(
    :value="dialogFaq",
    @input="dialogFaq = $event",
    persistent,
    width="calc(100% - 48px)",
    content-class="faq-editor-dialog"
  )
    v-card.faq-card.faq-editor-card(outlined)
      v-card-title.faq-dialog-header
        span {{ dialogFaqType }} de Artigo
      v-card-text.faq-editor-body.pt-6
        .faq-preview-loading.d-flex.justify-center.align-center(
          v-if="carregandoEdicao",
          role="status"
        )
          v-progress-circular(indeterminate, color="primary")
          span.ml-4 Carregando dados do artigo...
        .error--text.py-8.text-center(v-else-if="erroEdicao")
          | {{ erroEdicao }}
        v-form#faq-form-artigo(v-else, @submit.prevent="salvarFaq()")
          v-row
            v-col(cols="12", md="9")
              h4.font-weight-bold.mt-0.mb-2 Título do Artigo
              v-text-field.my-2(
                :value="artigoManipulate.titulo",
                @input="artigoManipulate.titulo = $event",
                placeholder="Digite o título do artigo",
                :disabled="salvandoArtigo",
                outlined,
                hide-details,
                dense
              )

              h4.font-weight-bold.mt-0.mb-2 Descrição
              v-text-field.mb-2(
                v-model="artigoManipulate.descricao",
                label="Descrição",
                :disabled="salvandoArtigo",
                outlined,
                hide-details,
                dense
              )

              h4.font-weight-bold.mt-0.mb-2 Conteúdo
              vue-editor.faq-vue-editor(
                :value="artigoManipulate.conteudo",
                @input="atualizarConteudoArtigo($event)",
                :editor-options="editorOptions",
                :disabled="salvandoArtigo",
                placeholder="Digite o conteúdo do artigo",
                @ready="onEditorReady($event)"
              )

            v-col(
              cols="12",
              md="3",
              style="background-color: #f5f5f5; height: calc(100vh - 180px); overflow-y: scroll"
            )
              h4.font-weight-bold.mt-0.mb-2 Seções
              v-card.faq-secoes-card.pa-2(outlined, elevation="0", tile)
                v-text-field.faq-secoes-busca(
                  :value="buscaSecao",
                  @input="buscaSecao = $event",
                  label="Pesquisar seção",
                  dense,
                  hide-details,
                  clearable,
                  prepend-inner-icon="mdi-magnify"
                )
                v-list.faq-list.faq-secoes-list.mt-2
                  v-list-item(
                    v-for="secao in secoesFiltradas",
                    :key="secao.value",
                    link,
                    @click="toggleSecaoDestino(secao.value)"
                  )
                    v-list-item-action
                      v-checkbox(
                        :input-value="secoesDestinoIds.includes(secao.value)",
                        color="primary",
                        hide-details,
                        dense,
                        @click.stop,
                        @change="toggleSecaoDestino(secao.value)"
                      )
                    v-list-item-content
                      v-list-item-title {{ secao.text }}
                  v-list-item(v-if="secoesFiltradas.length === 0")
                    v-list-item-content
                      v-list-item-title.grey--text Nenhuma seção encontrada
              .error--text.text-caption.mt-1(v-if="erroSecoesDestino")
                | Selecione ao menos uma seção.

              .mt-6
                .text-caption Editores do artigo
                .text-caption.font-weight-bold Criador: {{ artigoManipulate.autor || "—" }}
                .text-caption.font-weight-bold Último editor: {{ artigoManipulate.ultimoeditor || "—" }}

              .mt-6
                span.text--secondary
                  .text-caption.font-weight-bold Permissão {{ dialogFaqType === "Inclusão" ? "(habilita na edição)" : "" }}
                  .text-caption Permissão inicial: {{ dialogFaqType === "Inclusão" ? "Público" : artigoOriginal && artigoOriginal.permissao === "privado" ? "Privado" : "Público" }}
                  .text-caption(v-if="dialogFaqType !== 'Inclusão'") Permissão definida: {{ artigoManipulate.permissao === "privado" ? "Privado" : "Público" }}

              .d-flex.justify-end
                v-btn(
                  text,
                  :disabled="dialogFaqType === 'Inclusão' || salvandoArtigo || carregandoEdicao || !artigoOriginal",
                  @click="artigoManipulate.permissao = artigoManipulate.permissao === 'publico' ? 'privado' : 'publico'"
                ) {{ artigoManipulate.permissao === "privado" ? "Tornar público" : "Tornar privado" }}

              .mt-6
                span.text--secondary
                  .text-caption.font-weight-bold Status do Artigo {{ dialogFaqType === "Inclusão" ? "(habilita na edição)" : "" }}
                  .text-caption Status inicial: {{ nomeStatus(dialogFaqType === "Inclusão" ? "rascunho" : artigoOriginal && artigoOriginal.status) }}
                  .text-caption(v-if="dialogFaqType !== 'Inclusão'") Status definido: {{ nomeStatus(artigoManipulate.status) }}

              .d-flex.justify-end
                v-btn(
                  text,
                  :disabled="dialogFaqType === 'Inclusão' || salvandoArtigo || carregandoEdicao || !artigoOriginal",
                  @click="artigoManipulate.status = artigoManipulate.status === 'publicado' ? 'despublicado' : 'publicado'"
                ) {{ artigoManipulate.status === "publicado" ? "Despublicar" : "Publicar" }}

      v-card-actions.faq-dialog-actions.mr-0
        v-spacer
        v-btn.faq-btn-action.text-none(
          outlined,
          small,
          @click="closeDialogFaq()",
          :disabled="salvandoArtigo"
        )
          span Cancelar
        v-btn.faq-btn-primary.text-none(
          color="primary",
          small,
          type="submit",
          form="faq-form-artigo",
          :loading="salvandoArtigo",
          :disabled="salvandoArtigo || carregandoEdicao || !!erroEdicao"
        )
          span Salvar
</template>

<script>
import { VueEditor, Quill } from "vue2-editor";
import {
  buscarArtigoFaq,
  criarArtigoFaq,
  atualizarArtigoFaq,
  atualizarStatusArtigosFaq,
  excluirArtigoFaq,
} from "@/api/faq";
import { nomeStatus } from "@/utils/faqStatus";
import FaqStatus from "./FaqStatus.vue";
import { mensagemErroFaq } from "@/utils/faqErros";

const criarArtigoFormulario = () => ({
  id: null,
  titulo: "",
  descricao: "",
  autor: "",
  ultimoeditor: "",
  status: "rascunho",
  permissao: "publico",
  conteudo: "",
  video: false,
});
const conteudoTemVideo = (conteudo) =>
  /<(?:iframe|video)\b/i.test(conteudo || "");

const permitirCopiaVideosYoutube = (conteudo) => {
  if (!conteudo) return "";

  const documento = new DOMParser().parseFromString(conteudo, "text/html");
  documento.querySelectorAll("iframe[src]").forEach((iframe) => {
    let url;
    try {
      url = new URL(iframe.getAttribute("src"));
    } catch (erro) {
      return;
    }
    if (
      url.protocol !== "https:" ||
      ![
        "www.youtube.com",
        "www.youtube-nocookie.com",
        "youtube.com",
        "youtube-nocookie.com",
      ].includes(url.hostname)
    )
      return;

    const permissoes = (iframe.getAttribute("allow") || "")
      .split(";")
      .map((permissao) => permissao.trim())
      .filter(
        (permissao) => permissao && !/^clipboard-write(?:\s|$)/i.test(permissao)
      );
    permissoes.push("clipboard-write");
    iframe.setAttribute("allow", permissoes.join("; "));
  });
  return documento.body.innerHTML;
};

const textoConteudo = (conteudo) => {
  const documento = new DOMParser().parseFromString(conteudo, "text/html");
  documento
    .querySelectorAll("script, style")
    .forEach((elemento) => elemento.remove());
  return (documento.body.textContent || "")
    .replace(/[\u200B-\u200D\uFEFF]/g, "")
    .replace(/\s+/g, " ")
    .trim();
};

// O módulo de redimensionamento depende de window.Quill no momento do import.
window.Quill = Quill;
const ImageResizeModule = require("quill-image-resize-module");
const ImageResize = ImageResizeModule.default || ImageResizeModule;
Quill.register("modules/imageResize", ImageResize, true);
const itemContemOpcao = ([item, filtro]) =>
  Array.isArray(item[filtro.field]) &&
  item[filtro.field].includes(filtro.value);
export default {
  name: "FaqArtigos",
  components: {
    VueEditor,
    FaqStatus,
  },
  props: {
    podeEditar: { type: Boolean, default: false },
    recarregarResumo: { type: Function, required: true },
    recarregarArtigos: { type: Function, required: true },
    detalhesArtigos: { type: Array, required: true },
    ativo: {
      type: Boolean,
      default: true,
    },
    artigos: {
      type: Array,
      required: true,
    },
    dados: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      filterProps: {
        includeSearch: true,
        items: [
          {
            text: "Status",
            type: "select",
            selecteds: null,
            values: [
              {
                field: "status",
                text: "Publicado",
                value: "publicado",
              },
              {
                field: "status",
                text: "Rascunho",
                value: "rascunho",
              },
              {
                field: "status",
                text: "Despublicado",
                value: "despublicado",
              },
            ],
          },
          {
            text: "Permissão",
            type: "select",
            selecteds: null,
            values: [
              { field: "permissao", text: "Público", value: "publico" },
              { field: "permissao", text: "Privado", value: "privado" },
            ],
          },
          {
            text: "Categoria",
            type: "select",
            multiple: true,
            selecteds: [],
            values: [],
          },
          {
            text: "Seção",
            type: "select",
            multiple: true,
            selecteds: [],
            values: [],
          },
          {
            text: "Vídeo",
            type: "select",
            selecteds: null,
            values: [
              { field: "video", text: "Sim", value: true },
              { field: "video", text: "Não", value: false },
            ],
          },
          {
            text: "Último editor",
            type: "select",
            multiple: true,
            selecteds: [],
            values: [],
          },
        ],
        searchText: "",
      },
      footerProps: {
        itemsPerPageOptions: [20, 50, 100, 300, 500, -1],
        itemsPerPageAllText: "Todos",
        showCurrentPage: true,
        showFirstLastPage: true,
        itemsPerPageText: "Itens por página",
      },
      artigosSelecionados: [],
      salvandoArtigo: false,
      alterandoStatus: false,
      excluindoArtigo: false,
      dialogConfirmacaoStatus: false,
      statusArtigosPendente: null,
      dialogConfirmacaoExclusao: false,
      artigoExclusaoPendente: null,
      headersArtigos: [
        {
          text: "Status",
          value: "status",
          sortable: false,
          width: "70px",
          align: "center",
        },
        {
          text: "Título",
          value: "titulo",
        },
        {
          text: "Permissão",
          value: "permissao",
          sortable: false,
          width: "100px",
          align: "center",
        },
        {
          text: "Categorias",
          value: "categoria",
          width: "280px",
        },
        {
          text: "Seções",
          value: "secaoTitulo",
          width: "280px",
        },
        {
          text: "Métricas",
          value: "metricas",
          sortable: false,
          width: "120px",
          align: "center",
        },
        {
          text: "Vídeo",
          value: "video",
          sortable: false,
          width: "80px",
          align: "center",
        },
        { text: "Última edição", value: "ultimoeditor", width: "200px" },
        {
          text: "Atualizado",
          value: "atualizadoem",
          width: "150px",
          align: "center",
        },
        {
          text: "Ações",
          value: "actions",
          sortable: false,
          width: "120px",
          align: "center",
        },
      ],
      dialogArtigo: false,
      artigoVisualizado: null,
      carregandoVisualizacao: false,
      erroVisualizacao: "",
      requisicaoVisualizacao: 0,
      carregandoEdicao: false,
      erroEdicao: "",
      requisicaoEdicao: 0,
      dialogFaq: false,
      dialogFaqType: "Inclusão",
      artigoManipulate: criarArtigoFormulario(),
      artigoOriginal: null,
      quillEditor: null,
      editorOptions: {
        modules: {
          imageResize: {
            modules: ["Resize", "DisplaySize", "Toolbar"],
            overlayStyles: {
              border: "1px dashed #1976d2",
              zIndex: "10",
            },
            handleStyles: {
              width: "12px",
              height: "12px",
              backgroundColor: "#fff",
              border: "1px solid #1976d2",
            },
          },
        },
      },
      secoesDestinoIds: [],
      erroSecoesDestino: false,
      buscaSecao: "",
    };
  },
  created() {
    this.atualizarOpcoesFiltros();
    this.carregarArtigos();
  },
  watch: {
    artigosTabela: {
      immediate: true,
      handler() {
        this.atualizarOpcoesPessoas();
      },
    },
    estruturaCategorias() {
      this.atualizarOpcoesFiltros();
    },
    artigos() {
      const ids = new Set(this.artigos.map((item) => item.id));
      this.artigosSelecionados = this.artigosSelecionados.filter((item) =>
        ids.has(item.id)
      );
      if (this.artigoVisualizado && !ids.has(this.artigoVisualizado.id))
        this.fecharArtigo();
      if (this.dialogFaq && this.artigoManipulate.id !== null) {
        if (!ids.has(this.artigoManipulate.id)) this.closeDialogFaq();
      }
      this.$nextTick(() => {
        if (this.$refs.dataFilter) this.$refs.dataFilter.applyFilters();
      });
    },
  },
  computed: {
    headersArtigosVisiveis() {
      return this.headersArtigos.map((header) =>
        header.value === "actions"
          ? { ...header, width: this.podeEditar ? "120px" : "60px" }
          : header
      );
    },
    conteudoVisualizado() {
      return permitirCopiaVideosYoutube(
        this.artigoVisualizado && this.artigoVisualizado.conteudo
      );
    },
    statusFiltrado() {
      const filtro = this.filterProps.items.find(
        (item) => item.text === "Status"
      );
      return filtro.selecteds ? filtro.selecteds.value : null;
    },
    artigosTabela() {
      const detalhes = new Map(
        this.detalhesArtigos.map((artigo) => [artigo.id, artigo])
      );
      return this.artigos.map((item) => {
        const artigo = detalhes.get(item.id) || {};
        return {
          ...item,
          status: artigo.status || item.status,
          permissao: artigo.permissao ?? item.permissao,
          descricao: artigo.descricao,
          autor: artigo.autor || item.autor,
          video: artigo.video,
          criadoem: artigo.criadoem,
          ultimoeditor: artigo.ultimoeditor,
          atualizadoem: artigo.atualizadoem || item.atualizadoem,
          visualizacoes: artigo.visualizacoes,
          curtidasPositivas: artigo.curtidasPositivas,
          curtidasNegativas: artigo.curtidasNegativas,
        };
      });
    },
    estruturaCategorias() {
      return JSON.stringify(
        this.categorias.map((categoria) => ({
          id: categoria.id,
          titulo: categoria.titulo,
          secoes: categoria.secoes.map((secao) => ({
            id: secao.id,
            titulo: secao.titulo,
          })),
        }))
      );
    },
    totaisStatus() {
      const publicados = this.artigosTabela.filter(
        (artigo) => artigo.status === "publicado"
      ).length;
      const rascunhos = this.artigosTabela.filter(
        (artigo) => artigo.status === "rascunho"
      ).length;
      const despublicados = this.artigosTabela.filter(
        (artigo) => artigo.status === "despublicado"
      ).length;
      return {
        total: this.artigosTabela.length,
        rascunhos,
        publicados,
        despublicados,
      };
    },
    categorias() {
      return this.dados.categorias;
    },
    secoesOptions() {
      const options = [];
      this.categorias.forEach((categoria) => {
        categoria.secoes.forEach((secao) => {
          options.push({
            text: `${categoria.titulo} > ${secao.titulo}`,
            value: secao.id,
          });
        });
      });
      return options;
    },
    secoesFiltradas() {
      const termo = this.normalizarTexto(this.buscaSecao);
      if (!termo) return this.secoesOptions;
      return this.secoesOptions.filter((secao) =>
        this.normalizarTexto(secao.text).includes(termo)
      );
    },
  },
  methods: {
    filtrarStatus(status) {
      const filtro = this.filterProps.items.find(
        (item) => item.text === "Status"
      );
      const dataFilter = this.$refs.dataFilter;
      if (!filtro || !dataFilter) return;
      const selecionado =
        status && status !== this.statusFiltrado
          ? filtro.values.find((opcao) => opcao.value === status)
          : null;
      filtro.selecteds = selecionado || null;
      dataFilter.deleteFilter("Status");
      if (selecionado)
        dataFilter.filters.push({ chip: "Status", filter: selecionado });
      dataFilter.applyFilters();
    },
    nomeStatus,
    formatarDataArtigo(valor) {
      if (!valor) return "—";
      const data = new Date(valor);
      return Number.isNaN(data.getTime())
        ? valor
        : data.toLocaleString("pt-BR");
    },
    atualizarConteudoArtigo(conteudo) {
      this.artigoManipulate.conteudo = conteudo || "";
      this.artigoManipulate.video = conteudoTemVideo(conteudo);
    },
    async carregarArtigos() {
      try {
        const dados = await this.recarregarArtigos();
        if (this._isDestroyed || this._isBeingDestroyed) return;
        this.$nextTick(() => {
          if (this.$refs.dataFilter) this.$refs.dataFilter.applyFilters();
        });
        return dados;
      } catch (erro) {
        if (this._isDestroyed || this._isBeingDestroyed) return;
        console.error("Erro GET /v1/faq/artigos:", erro);
        this.$toast.error("Não foi possível buscar os artigos do FAQ");
      }
    },
    atualizarOpcoesFiltros() {
      const filtroCategorias = this.filterProps.items.find(
        (filtro) => filtro.text === "Categoria"
      );
      const filtroSecoes = this.filterProps.items.find(
        (filtro) => filtro.text === "Seção"
      );
      filtroCategorias.values = this.categorias.map((categoria) => ({
        field: "categoriaIds",
        text: categoria.titulo,
        value: categoria.id,
        fn: itemContemOpcao,
      }));
      filtroSecoes.values = this.categorias.reduce(
        (secoes, categoria) =>
          secoes.concat(
            categoria.secoes.map((secao) => ({
              field: "secaoIds",
              text: secao.titulo,
              value: secao.id,
              fn: itemContemOpcao,
            }))
          ),
        []
      );
    },
    atualizarOpcoesPessoas() {
      [{ nome: "Último editor", campo: "ultimoeditor" }].forEach(
        ({ nome, campo }) => {
          const filtro = this.filterProps.items.find(
            (item) => item.text === nome
          );
          const valores = [
            ...new Set(
              this.artigosTabela.map((artigo) => artigo[campo]).filter(Boolean)
            ),
          ];
          valores.sort((a, b) => a.localeCompare(b, "pt-BR"));
          filtro.values = valores.map((valor) => ({
            field: campo,
            text: valor,
            value: valor,
          }));
        }
      );
    },
    normalizarTexto(valor) {
      return (valor || "")
        .toString()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim();
    },
    filtrarBuscaArtigos(itens, busca) {
      const termo = this.normalizarTexto(busca);
      if (!termo) return itens;
      return itens.filter((item) =>
        Object.values(item).some((valor) =>
          valor != null && typeof valor !== "boolean" &&
          this.normalizarTexto(String(valor)).includes(termo)
        )
      );
    },
    toggleSecaoDestino(secaoId) {
      if (this.salvandoArtigo) return;
      const index = this.secoesDestinoIds.indexOf(secaoId);
      if (index === -1) {
        const softhouse = this.softhouseDaSecao(secaoId);
        if (
          this.secoesDestinoIds.some(
            (id) => this.softhouseDaSecao(id) !== softhouse
          )
        ) {
          this.$toast.error(
            "Todas as seções do artigo devem pertencer à mesma softhouse"
          );
          return;
        }
        this.secoesDestinoIds.push(secaoId);
      } else {
        this.secoesDestinoIds.splice(index, 1);
      }
      this.erroSecoesDestino = false;
    },
    async abrirArtigo(artigo) {
      if (!artigo) return;
      const requisicao = ++this.requisicaoVisualizacao;
      this.artigoVisualizado = artigo;
      this.erroVisualizacao = "";
      this.carregandoVisualizacao = true;
      this.dialogArtigo = true;
      try {
        const completo = await this.buscarArtigoCompleto(artigo.id);
        if (
          !completo ||
          requisicao !== this.requisicaoVisualizacao ||
          !this.dialogArtigo ||
          this._isDestroyed ||
          this._isBeingDestroyed
        )
          return;
        this.artigoVisualizado = completo;
      } catch (erro) {
        if (
          requisicao === this.requisicaoVisualizacao &&
          this.dialogArtigo &&
          !this._isDestroyed &&
          !this._isBeingDestroyed
        ) {
          console.error("Erro GET /v1/faq/artigos/:id:", erro);
          this.erroVisualizacao =
            "Não foi possível carregar o conteúdo do artigo.";
        }
      } finally {
        if (
          requisicao === this.requisicaoVisualizacao &&
          !this._isDestroyed &&
          !this._isBeingDestroyed
        )
          this.carregandoVisualizacao = false;
      }
    },
    async buscarArtigoCompleto(artigoId) {
      const completo = await buscarArtigoFaq(artigoId);
      if (
        !completo ||
        typeof completo !== "object" ||
        Array.isArray(completo)
      ) {
        throw new Error("Formato inválido ao consultar artigo");
      }
      return completo;
    },
    fecharArtigo() {
      this.requisicaoVisualizacao += 1;
      this.dialogArtigo = false;
      this.artigoVisualizado = null;
      this.erroVisualizacao = "";
      this.carregandoVisualizacao = false;
    },
    onDialogArtigoInput(aberto) {
      if (aberto) {
        this.dialogArtigo = true;
        return;
      }
      this.fecharArtigo();
    },
    onEditorReady(quill) {
      if (this.quillEditor && this.quillEditor.root) {
        this.quillEditor.root.removeEventListener(
          "scroll",
          this.hideImageResizeOverlay
        );
      }
      this.quillEditor = quill;
      quill.root.addEventListener("scroll", this.hideImageResizeOverlay);
    },
    hideImageResizeOverlay() {
      const imageResize =
        this.quillEditor && this.quillEditor.getModule("imageResize");
      if (imageResize && typeof imageResize.hide === "function") {
        imageResize.hide();
      }
    },
    novoArtigo() {
      if (!this.podeEditar) return;
      this.dialogFaqType = "Inclusão";
      this.artigoManipulate = criarArtigoFormulario();
      const usuario = this.$store.state.auth.user;
      this.artigoManipulate.autor = usuario
        ? usuario.name || usuario.login || ""
        : "";
      this.artigoManipulate.ultimoeditor = this.artigoManipulate.autor;
      this.buscaSecao = "";
      this.secoesDestinoIds = [];
      this.erroSecoesDestino = false;
      this.dialogFaq = true;
    },
    async editarArtigo(secao, artigo) {
      if (!this.podeEditar) return;
      if (!artigo) return;
      const requisicao = ++this.requisicaoEdicao;
      this.dialogFaqType = "Alteração";
      this.buscaSecao = "";
      this.erroSecoesDestino = false;
      this.erroEdicao = "";
      this.artigoManipulate = criarArtigoFormulario();
      this.artigoOriginal = null;
      this.secoesDestinoIds = [];
      this.carregandoEdicao = true;
      this.dialogFaq = true;
      try {
        const completo = await this.buscarArtigoCompleto(artigo.id);
        if (
          !completo ||
          requisicao !== this.requisicaoEdicao ||
          !this.dialogFaq ||
          this._isDestroyed ||
          this._isBeingDestroyed
        )
          return;

        const secoes = (completo.sessoes || [])
          .map((sessao) => this.getSecaoById(sessao.id))
          .filter(Boolean);
        if (secoes.length > 0) {
          this.secoesDestinoIds = secoes.map((item) => item.id);
        } else {
          const secoesResumo = this.getSecoesByArtigoId(artigo.id);
          this.secoesDestinoIds =
            secoesResumo.length > 0
              ? secoesResumo.map((item) => item.id)
              : secao
              ? [secao.id]
              : [];
        }
        this.artigoManipulate = {
          id: completo.id,
          titulo: completo.titulo || "",
          descricao: completo.descricao || "",
          autor: completo.autor || "",
          ultimoeditor: completo.ultimoeditor || "",
          status: completo.status || "despublicado",
          permissao: completo.permissao || artigo.permissao || "publico",
          conteudo: completo.conteudo || "",
          video: conteudoTemVideo(completo.conteudo),
        };
        this.artigoOriginal = {
          titulo: completo.titulo || "",
          descricao: completo.descricao || "",
          conteudo: completo.conteudo || "",
          video: Boolean(completo.video),
          idsessoes: this.secoesDestinoIds.slice(),
          status: completo.status || "despublicado",
          permissao: completo.permissao || artigo.permissao || "publico",
        };
        this.dialogFaq = true;
      } catch (erro) {
        if (
          requisicao === this.requisicaoEdicao &&
          this.dialogFaq &&
          !this._isDestroyed &&
          !this._isBeingDestroyed
        ) {
          console.error("Erro ao carregar artigo para edição:", erro);
          this.erroEdicao = "Não foi possível carregar o artigo para edição.";
        }
      } finally {
        if (
          requisicao === this.requisicaoEdicao &&
          !this._isDestroyed &&
          !this._isBeingDestroyed
        )
          this.carregandoEdicao = false;
      }
    },
    solicitarExclusaoArtigoCompleto(artigo) {
      if (!this.podeEditar) return;
      if (this.excluindoArtigo) return;
      this.artigoExclusaoPendente = artigo;
      this.dialogConfirmacaoExclusao = true;
    },
    cancelarExclusaoArtigo() {
      if (this.excluindoArtigo) return;
      this.dialogConfirmacaoExclusao = false;
      this.artigoExclusaoPendente = null;
    },
    solicitarAlteracaoStatusArtigos(status) {
      if (!this.podeEditar) return;
      if (this.artigosSelecionados.length === 0) return;
      this.statusArtigosPendente = status;
      this.dialogConfirmacaoStatus = true;
    },
    cancelarAlteracaoStatusArtigos() {
      if (this.alterandoStatus) return;
      this.dialogConfirmacaoStatus = false;
      this.statusArtigosPendente = null;
    },
    async confirmarAlteracaoStatusArtigos() {
      if (!this.podeEditar) return;
      if (this.alterandoStatus) return;
      const status = this.statusArtigosPendente;
      const idsSelecionados = [
        ...new Set(this.artigosSelecionados.map((artigo) => artigo.id)),
      ];
      if (status === null || idsSelecionados.length === 0) return;
      const usuario = this.$store.state.auth.user;
      const ultimoeditor = usuario
        ? (usuario.name || usuario.login || "").trim()
        : "";
      if (!ultimoeditor) {
        this.$toast.error(
          "Não foi possível identificar o editor. Verifique sua sessão de usuário."
        );
        return;
      }
      this.alterandoStatus = true;
      try {
        await atualizarStatusArtigosFaq({
          ids: idsSelecionados,
          status,
          ultimoeditor,
          atualizadoem: new Date().toISOString(),
        });
        if (this._isDestroyed || this._isBeingDestroyed) return;
        this.dialogConfirmacaoStatus = false;
        this.statusArtigosPendente = null;
        this.artigosSelecionados = [];
        this.$toast.success(
          `Status de ${
            idsSelecionados.length
          } artigo(s) atualizado para ${this.nomeStatus(status).toLowerCase()}`
        );
        await this.carregarArtigos();
        try {
          await this.recarregarResumo();
        } catch (erro) {
          if (!this._isDestroyed && !this._isBeingDestroyed) {
            this.$toast.error(
              "Status atualizado, mas não foi possível atualizar as categorias. Recarregue a página."
            );
          }
        }
      } catch (erro) {
        if (!this._isDestroyed && !this._isBeingDestroyed) {
          this.$toast.error(
            mensagemErroFaq(
              erro,
              "Não foi possível alterar o status dos artigos. Nenhuma alteração foi confirmada."
            )
          );
        }
      } finally {
        if (!this._isDestroyed && !this._isBeingDestroyed)
          this.alterandoStatus = false;
      }
    },
    async excluirArtigoCompleto(artigo) {
      if (!this.podeEditar) return;
      if (this.excluindoArtigo || !artigo) return;
      this.excluindoArtigo = true;
      try {
        await excluirArtigoFaq(artigo.id);
      } catch (erro) {
        if (!this._isDestroyed && !this._isBeingDestroyed) {
          this.$toast.error(
            mensagemErroFaq(
              erro,
              "Não foi possível excluir o artigo. Tente novamente."
            )
          );
          this.excluindoArtigo = false;
        }
        return;
      }
      if (this._isDestroyed || this._isBeingDestroyed) return;
      this.artigosSelecionados = this.artigosSelecionados.filter(
        (item) => item.id !== artigo.id
      );
      if (this.dialogFaq && this.artigoManipulate.id === artigo.id) {
        this.closeDialogFaq();
      }
      if (this.artigoVisualizado && this.artigoVisualizado.id === artigo.id) {
        this.fecharArtigo();
      }
      this.dialogConfirmacaoExclusao = false;
      this.artigoExclusaoPendente = null;
      this.$toast.success("Artigo excluído com sucesso");
      try {
        await this.carregarArtigos();
        await this.recarregarResumo();
      } catch (erro) {
        if (!this._isDestroyed && !this._isBeingDestroyed) {
          this.$toast.error(
            "Artigo excluído, mas não foi possível atualizar a listagem. Recarregue a página."
          );
        }
      } finally {
        if (!this._isDestroyed && !this._isBeingDestroyed)
          this.excluindoArtigo = false;
      }
    },
    getSecaoById(secaoId) {
      for (const categoria of this.categorias) {
        const secao = categoria.secoes.find((item) => item.id === secaoId);
        if (secao) return secao;
      }
      return null;
    },
    getSecoesByArtigoId(artigoId) {
      const secoes = [];
      this.categorias.forEach((categoria) => {
        categoria.secoes.forEach((secao) => {
          if (secao.artigos.some((artigo) => artigo.id === artigoId)) {
            secoes.push(secao);
          }
        });
      });
      return secoes;
    },
    closeDialogFaq(forcar = false) {
      if (this.salvandoArtigo && !forcar) return;
      this.requisicaoEdicao += 1;
      this.carregandoEdicao = false;
      this.erroEdicao = "";
      this.hideImageResizeOverlay();
      this.dialogFaq = false;
      this.artigoManipulate = criarArtigoFormulario();
      this.artigoOriginal = null;
      this.secoesDestinoIds = [];
      this.erroSecoesDestino = false;
      this.buscaSecao = "";
      this.dialogFaqType = "Inclusão";
    },
    softhouseDaSecao(id) {
      const categoria = this.categorias.find((item) =>
        item.secoes.some((secao) => secao.id === id)
      );
      const secao =
        categoria && categoria.secoes.find((item) => item.id === id);
      return secao
        ? secao.softhouse || categoria.softhouse || "CONTROLSOFT"
        : null;
    },
    async salvarFaq() {
      if (!this.podeEditar) return;
      if (this.salvandoArtigo) return;
      const titulo = (this.artigoManipulate.titulo || "").trim();
      const secoesDestino = this.secoesDestinoIds
        .map((secaoId) => this.getSecaoById(secaoId))
        .filter(Boolean);
      if (!titulo) {
        this.$toast.error("Título é obrigatório");
        return;
      }
      const descricao = (this.artigoManipulate.descricao || "").trim();
      const conteudo = (this.artigoManipulate.conteudo || "").trim();
      if (Array.from(textoConteudo(conteudo)).length < 20) {
        this.$toast.error(
          "O conteúdo deve ter no mínimo 20 caracteres de texto"
        );
        return;
      }
      if (
        secoesDestino.length === 0 ||
        secoesDestino.length !== this.secoesDestinoIds.length
      ) {
        this.erroSecoesDestino = true;
        this.$toast.error("Selecione ao menos uma seção");
        return;
      }
      const video = conteudoTemVideo(conteudo);
      this.artigoManipulate.video = video;
      const softhouses = new Set(
        secoesDestino.map((secao) => this.softhouseDaSecao(secao.id))
      );
      if (softhouses.size !== 1) {
        this.$toast.error(
          "Todas as seções do artigo devem pertencer à mesma softhouse"
        );
        return;
      }
      const usuario = this.$store.state.auth.user;
      const ultimoeditor = usuario
        ? (usuario.name || usuario.login || "").trim()
        : "";
      if (!ultimoeditor) {
        this.$toast.error(
          "Não foi possível identificar o editor. Verifique sua sessão de usuário."
        );
        return;
      }
      const atualizadoem = new Date().toISOString();
      if (this.dialogFaqType === "Inclusão") {
        const autor = (this.artigoManipulate.autor || "").trim();
        if (!autor) {
          this.$toast.error(
            "Não foi possível identificar o autor. Verifique sua sessão de usuário."
          );
          return;
        }
        this.salvandoArtigo = true;
        try {
          await criarArtigoFaq({
            idsessoes: secoesDestino.map((secao) => secao.id),
            titulo,
            descricao,
            conteudo,
            video,
            autor,
            ultimoeditor,
            atualizadoem,
            criadoem: atualizadoem,
          });
          if (this._isDestroyed || this._isBeingDestroyed) return;
          this.closeDialogFaq(true);
          this.$toast.success("Artigo incluído com sucesso");
          await this.carregarArtigos();
          try {
            await this.recarregarResumo();
          } catch (erro) {
            if (!this._isDestroyed && !this._isBeingDestroyed) {
              this.$toast.error(
                "Artigo salvo, mas não foi possível atualizar a listagem. Recarregue a página."
              );
            }
          }
        } catch (erro) {
          if (!this._isDestroyed && !this._isBeingDestroyed) {
            this.$toast.error(
              mensagemErroFaq(
                erro,
                "Não foi possível incluir o artigo. Verifique os dados e tente novamente."
              )
            );
          }
        } finally {
          if (!this._isDestroyed && !this._isBeingDestroyed)
            this.salvandoArtigo = false;
        }
        return;
      }

      const idsessoes = secoesDestino.map((secao) => secao.id);
      const idsOrdenados = (ids) => ids.map(String).sort();
      const idsOriginais = idsOrdenados(
        (this.artigoOriginal && this.artigoOriginal.idsessoes) || []
      );
      const idsSelecionados = idsOrdenados(idsessoes);
      const sessoesAlteradas =
        idsOriginais.length !== idsSelecionados.length ||
        idsOriginais.some((id, index) => id !== idsSelecionados[index]);
      const alteracoes = {};
      if (titulo !== (this.artigoOriginal && this.artigoOriginal.titulo)) {
        alteracoes.titulo = titulo;
      }
      if (
        descricao !== (this.artigoOriginal && this.artigoOriginal.descricao)
      ) {
        alteracoes.descricao = descricao;
      }
      if (conteudo !== (this.artigoOriginal && this.artigoOriginal.conteudo)) {
        alteracoes.conteudo = conteudo;
      }
      if (video !== Boolean(this.artigoOriginal && this.artigoOriginal.video)) {
        alteracoes.video = video;
      }
      if (sessoesAlteradas) alteracoes.idsessoes = idsessoes;
      if (this.artigoManipulate.status !== this.artigoOriginal.status) {
        alteracoes.status = this.artigoManipulate.status;
      }
      if (this.artigoManipulate.permissao !== this.artigoOriginal.permissao) {
        alteracoes.permissao = this.artigoManipulate.permissao;
      }
      alteracoes.ultimoeditor = ultimoeditor;
      alteracoes.atualizadoem = atualizadoem;

      this.salvandoArtigo = true;
      try {
        await atualizarArtigoFaq(this.artigoManipulate.id, alteracoes);
        if (this._isDestroyed || this._isBeingDestroyed) return;
        this.closeDialogFaq(true);
        this.$toast.success("Artigo alterado com sucesso");

        const artigosAtualizados = await this.carregarArtigos();
        if (!artigosAtualizados) {
          this.$toast.error(
            "Artigo alterado, mas não foi possível atualizar a listagem de artigos. Recarregue a página."
          );
        }
        try {
          await this.recarregarResumo();
        } catch (erro) {
          if (!this._isDestroyed && !this._isBeingDestroyed) {
            this.$toast.error(
              "Artigo alterado, mas não foi possível atualizar as seções. Recarregue a página."
            );
          }
        }
      } catch (erro) {
        if (!this._isDestroyed && !this._isBeingDestroyed) {
          this.$toast.error(
            mensagemErroFaq(
              erro,
              "Não foi possível alterar o artigo. Verifique os dados e tente novamente."
            )
          );
        }
      } finally {
        if (!this._isDestroyed && !this._isBeingDestroyed)
          this.salvandoArtigo = false;
      }
    },
    async confirmarExclusaoArtigo() {
      if (this.excluindoArtigo) return;
      const artigo = this.artigoExclusaoPendente;
      if (artigo) await this.excluirArtigoCompleto(artigo);
    },
  },
  beforeDestroy() {
    if (this.quillEditor && this.quillEditor.root) {
      this.quillEditor.root.removeEventListener(
        "scroll",
        this.hideImageResizeOverlay
      );
    }
  },
};
</script>

<style scoped>
.faq-artigos-data-table {
  min-height: 0;
}

.faq-artigos-footer {
  gap: 6px;
}

.faq-artigos-empty {
  position: sticky;
  left: 0;
  width: min(100%, calc(100vw - 48px));
  text-align: center;
  font-style: italic;
}

.faq-artigos-data-table ::v-deep .v-data-table__wrapper {
  min-height: calc(100vh - 300px);
  max-height: calc(100vh - 300px);
  overflow-x: auto;
  overflow-y: auto;
}

.faq-artigos-data-table ::v-deep table {
  width: max-content;
  min-width: 100%;
}

.faq-artigos-data-table ::v-deep th,
.faq-artigos-data-table ::v-deep td {
  white-space: nowrap;
}

@media (max-width: 959px) {
  .faq-artigos-data-table ::v-deep .v-data-table__wrapper {
    max-height: none;
  }
}
</style>
